module.exports = __webpack_public_path__ + "static/media/upload.83bcb1b6.svg";